import {
  CHANGE_LOGIN_BUTTON_MESSAGE,
  CHANGE_LOGIN_ERROR_MESSAGE,
  SHOW_PASSWORD_SET_SUCCESS,
  LOAD_DATA,
  LOAD_DATA_VIA_TOKEN,
  HIDE_MODAL_PASSWORD,
  LOGOUT,
  ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  ADD_VIDEO,
  UPDATE_VIDEO,
  CHANGE_ACTIVE_ACCOUNT,
  UPDATE_ACTIVE_ACCOUNT,
  UPDATE_CAMPAIGN_NAME
} from '../actions'
import loginReducer from './loginReducer'
import campaignReducer from './campaignReducer'
import appReducer from './appReducer'
import { saveKeenEvent } from '../utils/KeenTracking'

export const initialState = {
  isAuth: false,
  showPasswordSetSuccess: false,
  showModalPassword: false,
  loginMessage: 'Acessar',
  errorMessage: '',
  user: {},
  activeAccount: {},
  accounts: []
}

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LOGIN_BUTTON_MESSAGE:
    case CHANGE_LOGIN_ERROR_MESSAGE:
    case SHOW_PASSWORD_SET_SUCCESS:
    case HIDE_MODAL_PASSWORD:
      return loginReducer(state, action)
    case ADD_CAMPAIGN:
    case ADD_VIDEO:
    case UPDATE_VIDEO:
    case UPDATE_CAMPAIGN:
    case UPDATE_CAMPAIGN_NAME:
      return campaignReducer(state, action)
    case LOGOUT:
    case LOAD_DATA:
    case LOAD_DATA_VIA_TOKEN:
    case CHANGE_ACTIVE_ACCOUNT:
    case UPDATE_ACTIVE_ACCOUNT:
      return appReducer(state, action)
    case '@@router/LOCATION_CHANGE':
      saveKeenEvent('page-view')
      return state
    default:
      return state
  }
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js